(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fireworks-canvas"] && !window.DesignMode) return;
  try {
    
   var fireworksFn = (function(){
            function Fireworks(){
              this.init();
            }
        
          // 定义一个名为 Particle 的构造函数
          function Particle(xPoint, yPoint, size = 10) {
            // 粒子的宽度和高度是一个随机值，范围在 1 到 5 之间
            this.w = this.h = Math.random()*4+1;  
            // 粒子的初始 x 坐标是随机生成的，位于画布宽度减去 200 像素的范围内
            this.x = xPoint-this.w/2;
            // 粒子的初始 y 坐标是随机生成的，位于画布高度减去 200 像素的范围内
            this.y = yPoint-this.h/2;     
            // 粒子的初始水平速度是一个随机值，范围在 -5 到 5 之间
            this.vx = (Math.random()-0.5)*size;
            // 粒子的初始垂直速度是一个随机值，范围在 -5 到 5 之间
            this.vy = (Math.random()-0.5)*size;    
            // 粒子的初始透明度是一个随机值，范围在 0.5 到 1 之间
            this.alpha = Math.random()*.5+.5;    
            // 定义粒子透明度衰减速度
            this.fade = Math.random() * 0.04 + 0.01, 
            // 粒子的颜色是随机生成的 RGB 颜色
            this.color = this.colors[~~(Math.random()*this.colors.length)];
          } 
          // 为 Particle 构造函数的原型对象添加属性和方法
          Particle.prototype = {
            // 定义粒子颜色数组
            // colors: ["#ff387e", "#fed928", "#ff5a09", "#f2e3c2"],
            colors: ["#D32F2F", "#FFD700", "#4682B4", "#F8F9FA"],
            // 定义重力加速度
            gravity: 0.05,
            history: [],
            // 定义粒子缓存时长
            cache: 5,
            // 定义粒子透明度衰减速度
            fade: 0.05,
        
            /**
             * 更新粒子的位置并检查其是否存活
             * @returns {boolean} 如果粒子存活，返回 true；否则返回 false
             */
            move: function () {
              this.x += this.vx;
              this.vy += this.gravity;
              this.y += this.vy;
              this.alpha -= 0.01;
              if (this.x <= -this.w || this.x >= screen.width || this.y >= screen.height || this.alpha <= 0) {
                return false;
              }
              return true;
            },
        
            /**
             * 在画布上绘制粒子
             * @param {CanvasRenderingContext2D} c - 2D 渲染上下文
             */
            draw: function (c) {
              // this.drawHistory(c);
              const particle = {
                x: this.x,
                w: this.w,
                y: this.y,
                h: this.h,
                color: this.color,
                alpha: this.alpha
              };
              this.history.unshift(particle);
              this.history = this.history.reduce((res, cur) => {
                if(cur.alpha - this.fade > 0 && res.length < this.cache){
                  res.push({ ...cur, alpha: cur.alpha - this.fade });
                }
                return res;
              }, []);
              this.drawParticle(c, particle);
            },
            drawHistory(c){
              this.history.forEach(item => {
                if(this.alpha > 0){
                  this.drawParticle(c, item);
                }
              });
            },
            drawParticle(c, particle){
              // console.log(this.history);
              c.save();
              c.beginPath();         
              c.translate(particle.x+particle.w/2, particle.y+particle.h/2);
              c.arc(0, 0, particle.w, 0, Math.PI*2);
              c.fillStyle = particle.color;
              c.globalAlpha = particle.alpha;         
              c.closePath();
              c.fill();
              c.restore();
            }
          } 
        
            Fireworks.prototype = Object.assign({}, Fireworks.prototype, {
              init: function(){
                var canvas, ctx, w, h, particles = [], probability = 0.02, xPoint, yPoint;
                window.addEventListener("resize", resizeCanvas, false);
                window.requestAnimationFrame = 
                window.requestAnimationFrame       || 
                window.webkitRequestAnimationFrame || 
                window.mozRequestAnimationFrame    || 
                window.oRequestAnimationFrame      || 
                window.msRequestAnimationFrame     || 
                function (callback) {
                    window.setTimeout(callback, 1000/60);
                };
        
                function onLoad() {
                  canvas = document.getElementById("fireworks-canvas");
                  ctx = canvas.getContext("2d");
                  resizeCanvas();     
                  window.requestAnimationFrame(updateWorld);
                } 
                onLoad();
         
          function resizeCanvas() {
            if (!!canvas) {
              w = canvas.width = window.innerWidth;
              h = canvas.height = window.innerHeight;
            }
          } 
        
          function updateWorld() {
            update();
            paint();
            window.requestAnimationFrame(updateWorld);
          } 
        
          // 更新粒子状态并绘制粒子
          function update() {
            // 如果粒子数量少于 500 且随机概率小于 0.04，则创建新的烟花
            if (particles.length < 500 && Math.random() < probability) {
                createFirework();
            }
            var alive = [];
            // 遍历粒子数组，更新每个粒子的位置并检查其是否存活
            for (var i=0; i<particles.length; i++) {
                // 如果粒子移动后仍然存活，则将其添加到存活数组中
                if (particles[i].move()) {
                    alive.push(particles[i]);
                }
            }
            // 更新粒子数组为存活的粒子数组
            particles = alive;
          } 
        
          // 绘制粒子
          function paint() {
            // 设置全局合成操作，将新绘制的内容绘制在原有内容之上
            ctx.globalCompositeOperation = 'source-over';
            // 设置填充颜色为半透明的黑色
            // ctx.fillStyle = "rgba(0, 0, 0, 0.2)";
            // // 填充整个画布，以清除上一帧的内容
            // ctx.fillRect(0, 0, w, h);
        
            ctx.clearRect(0, 0, w, h);
            // 设置全局合成操作，将新绘制的内容与原有内容进行叠加
            ctx.globalCompositeOperation = 'lighter';
            // 遍历粒子数组，绘制每个粒子
            for (var i=0; i<particles.length; i++) {
                // 绘制粒子
                particles[i].draw(ctx);
            }
          } 
        
          // 创建烟花
          function createFirework() {
            // 随机生成烟花的 x 和 y 坐标
            xPoint = Math.random()*(w-200)+100;
            yPoint = Math.random()*(h-200)+100;
            // 随机生成烟花比例
            const random = Math.random();
            // 随机生成烟花中的粒子数量
            var nFire = random * 200 + 50;
            // 随机生成烟花的颜色
            // var c = "rgb("+(~~(Math.random()*200+55))+","+(~~(Math.random()*200+55))+","+(~~(Math.random()*200+55))+")";
            // 随机生成烟花范围
            var size = random * 8 + 2;
            // 遍历生成的粒子数量，创建每个粒子并设置其颜色
            for (var i=0; i<nFire; i++) {
                // 创建新的粒子
                var particle = new Particle(xPoint, yPoint, size);
                // 设置粒子的颜色
                // particle.color = c;
                // 计算粒子的初始速度
                var vy = Math.sqrt(25-particle.vx*particle.vx);
                // 如果粒子的垂直速度超过了允许的最大值，则将其限制在最大值内
                if (Math.abs(particle.vy) > vy) {
                    particle.vy = particle.vy>0? vy: -vy;
                }
                // 将粒子添加到粒子数组中
                particles.push(particle);
            }
          }
              }
            });
           
           return Fireworks.prototype.init;
          })();

          fireworksFn()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation"] && !window.DesignMode) return;
  try {
    
  var headerHeight = parseInt(getComputedStyle($one('.header')).height) -1;
  var html = "";
  $$('[navigation-title]').forEach(function(element){
    var title = element.getAttribute('navigation-title');
    if(title){
      html += "<span>"+title+"</span>";
    }
  });
  $one('.navigation_fixed .q_pageBox-box').innerHTML = html;

  $$('.q_pageBox-box > span').forEach(function(element, index){
    element.addEventListener('click', function(event){
      var top = $$('[navigation-title]')[index].offsetTop - parseInt(getComputedStyle($one('.navigation_fixed')).height) - headerHeight;
      $$('.q_pageBox-box > span').forEach(function(el, ii){
        el.classList.remove('active');
      });
      element.classList.add('active');
      window.scrollTo(0, top);
    });
  });

  /*
  $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      for (var i = $('.target').length - 1; i >= 0; i--) {
          if (scrollTop > $('.target').eq(i).offset().top - $('.q_pageBox-nav').outerHeight(true) - 2) {
              $('.q_pageBox-box a:not(.th1Logo)').eq(i).addClass('active').siblings('a').removeClass('active');
              $('.q_pageBoxOvs').stop().animate({ scrollLeft: $('.q_pageBox-box a:not(.th1Logo)').eq(i).position().left - $(window).width() * .2 }, 100);
              return false
          }
      }
  });
  */

  const pageHeight = document.documentElement.scrollHeight;
  const viewportHeight = window.innerHeight;
  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop >= viewportHeight) {
      $one('.navigation_fixed').classList.add('active');
    } else {
      $one('.navigation_fixed').classList.remove('active');
    }

    for (var i = $$('[navigation-title]').length - 1; i >= 0; i--) {
        if (scrollTop > $$('[navigation-title]')[i].offsetTop - parseInt(getComputedStyle($one('.navigation_fixed')).height) - headerHeight - 2) {
            $$('.q_pageBox-box > span').forEach(function(el, ii){
              el.classList.remove('active');
            });
            $$('.q_pageBox-box > span')[i].classList.add('active');
            //$('.q_pageBoxOvs').stop().animate({ scrollLeft: $('.q_pageBox-box > span')[i].position().left - $(window).width() * .2 }, 100);
            return false
        }
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-compare-page-tab"] && !window.DesignMode) return;
  try {
    
   var itemFirst = $$('.product_compare_page')[0];
   itemFirst.classList.add('active');
   itemFirst.classList.add('open');
   function setTabShow(){
    var span = $$('.product-compare-page-tab_content span');
    var content = $$('.product_compare_page');
    span.addEventListener('click', function(evevt, index){
        console.log(index, span, evevt.target);
        span.forEach(function(element, ii){
          if(ii == index){
            element.classList.add('active');
          }else{
            element.classList.remove('active');
          }
        });
        span.forEach(function(element, ii){
          if(ii == index){
            element.classList.add('active');
          }else{
            element.classList.remove('active');
          }
        });
        content.forEach(function(element, ii){
          if(ii == index){
            element.show();
          }else{
            element.hide();
          }
        });
    });
  }
 setTabShow();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-compare-page"] && !window.DesignMode) return;
  try {
    

  $$('.product_compare_page').forEach(function(compare_box){
    var compareKeyArr = [];
    var len = 4;

    if(theme.mediaMatches.md && !theme.mediaMatches.lg){
      len = 3;
    } else if(!theme.mediaMatches.md){
      len = 2;
    }

    if(compare_box.querySelectorAll('.compare-row--select select option').length > 0){
      initSetArr();
    }
    function initSetArr() {
      if(compareKeyArr.length == 0){
        for(var i = 1; i < len+1; i++){
          var item = compare_box.querySelectorAll('.compare-row--select select option')[i];
          var value = item.getAttribute('value');
          compareKeyArr.push(value);
          compare_box.querySelectorAll('.compare-row--select select')[i-1].value = value;
        }
      }
      setHtml();
      compare_box.querySelector('.loading-spinner').setAttribute('hidden', 'true');
      compare_box.querySelector('.js-compare-area').classList.add('revealable--in');
    }
    function setArr() {
      compareKeyArr = [];
      for(var i = 0; i < len; i++){
        var value = compare_box.querySelectorAll('.compare-row--select select')[i].value;
        compareKeyArr.push(value);
      }
      console.log(compareKeyArr);
      setHtml();
    }
    function setHtml() {
      compare_box.querySelectorAll('.compare-row--select option').forEach(function(element){
        var value = element.getAttribute('value');
        if(compareKeyArr.indexOf(value) != -1 && value != "none"){
          element.setAttribute('disabled', 'true');
        } else {
          element.removeAttribute('disabled');
        }
      });

      for(var i = 0; i< compareKeyArr.length; i++){
        var key = compareKeyArr[i];
        compare_box.querySelector('.product-compare-page-item[data-handle='+key+']').querySelectorAll('.compare-col').forEach(function(element) {
          var compare_key =  '.compare-row--' + element.getAttribute('data-compare-key').replace('compare-', '');
          if(i==0){
            compare_box.querySelector(compare_key).innerHTML = "";
          }
          compare_box.querySelector(compare_key).appendChild(element.cloneNode(true));
        });
      }
      setWeightColor();
    }
  
    function setWeightColor() {
      var index = 1;
      do{
        var arr = [];
        var items = compare_box.querySelectorAll('.compare-container [data-compare-key="compare-metafield-'+index+'"]');
        items.forEach(function(element){
          try {
            var item = element.querySelector('.compare-value');
            var text = parseInt(item.textContent);
            if(!isNaN(text)){
              arr.push(text);
            }else{
              arr.push(0);
            }
          } catch (error) {
            
          }
        });
        console.log(arr);
        var maxValue = Math.max(...arr);
        if(maxValue != 0){
          try {
          var maxIndex = arr.indexOf(maxValue);
          items[maxIndex].querySelector('.compare-value').classList.add('weightColor');
          } catch (error) {
            console.log*(error)
          }
        }
        index++
      } while (compare_box.querySelectorAll('.compare-container [data-compare-key="compare-metafield-'+index+'"]').length>0)
    }

    compare_box.querySelectorAll('.compare-row--select select').addEventListener('change', function(index, el){
      setArr();
    });

    compare_box.querySelectorAll('.compare-row--select .icon-close').addEventListener('click', function(el, index){
        var select = compare_box.querySelectorAll('.compare-row--select select')[index];
        select.value = "none";
        select.dispatchEvent(new Event('change'));
    });
    
  });

  } catch(e) { console.error(e); }
})();
})();
